// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { WidgetGrid, JarvisWidget } from 'wdna-components/lib';

import { ContextType, FilterContext } from '../../../../../types';
import Chart from './Chart';

type Props = unknown;
type State = unknown;

export default class Graph extends React.Component<Props, State> {
  private mounted: boolean;

  public static contextType: React.Context<ContextType> = FilterContext;
  public context: React.ContextType<typeof FilterContext> | undefined;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.state = {
    };
  }

  public componentDidMount = (): void => {
    this.mounted = true;
  };

  public componentWillUnmount = (): void => {
    this.mounted = false;
  };

  public render(): JSX.Element {
    return (
      <div id="content" className="content">
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12 col-md-12 col-lg-12">
              <JarvisWidget
                editbutton={false}
                togglebutton={false}
                colorbutton={false}
                deletebutton={false}
                custombutton={false}
                fullscreenbutton={false}
              >
                <div className="container" style={{ paddingTop: '0px' }}>
                  <br /><br />
                  <Chart formValues={this.context?.parentState} />
                  <br /><br />
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
